export const getAppointmnetData = (store) => store.appointmentform.editData;
